export default __webpack_public_path__ + "static/media/LOGO-02.496931f6.png";